/**
 * Turnover split by EMTAK activity: one proportional bar per line of business.
 *
 * Shared by the section footer (newest reported year) and by an unfolded table
 * row (that row's year), which is why it takes rows rather than the entity.
 */
import { Badge } from "@wa/ui";
import { formatEurFull, formatEurShort, type ArReportActivity } from "../../../../lib/ariregister";
import type { T } from "./lib";

/** Widest bar the eye can compare against; beyond this the list stops informing. */
const MAX_ROWS = 8;

export function ActivityBars({ rows, t }: { rows: ArReportActivity[]; t: T }) {
  const top = rows.slice(0, MAX_ROWS);
  if (top.length === 0) return null;
  const max = Math.max(...top.map((a) => a.revenueCents ?? 0), 1);
  return (
    <ul className="space-y-1.5">
      {top.map((a) => (
        <li key={a.id} className="flex items-center gap-2 text-sm">
          <span className="w-14 shrink-0 font-mono text-xs text-muted-foreground">{a.emtak}</span>
          <div className="relative h-5 flex-1 overflow-hidden rounded bg-muted/40">
            <div
              className="h-full rounded bg-primary/30"
              style={{ width: `${Math.round(((a.revenueCents ?? 0) / max) * 100)}%` }}
            />
          </div>
          {a.isMain && (
            <Badge variant="default" className="shrink-0 text-[10px]">
              {t("ariregister.detail.primary")}
            </Badge>
          )}
          <span className="w-24 shrink-0 text-right text-xs tabular-nums" title={formatEurFull(a.revenueCents)}>
            {formatEurShort(a.revenueCents)}
          </span>
        </li>
      ))}
    </ul>
  );
}
